import React, { Component } from "react";

import styles from "./styles.scss";
import * as router from "react-router-redux";
import { connect } from "react-redux";
import { actions } from "./redux";
import {
	Button,
	Card,
	CardContent,
	Grid,
	Select,
	MenuItem,
	CardHeader,
	CircularProgress,
	Modal
} from "@material-ui/core";
import {
	ArrowDropDown,
	ArrowDropUp,
	Close,
	Assessment,
	ViewStream,
	ViewModule,
	MoreVert,
	Settings,
	Refresh,
	ErrorOutline,
	CenterFocusStrong
} from "@material-ui/icons";
import Highcharts from "highcharts";
import ReactHighcharts from "react-highcharts";
import CSSModules from "react-css-modules";
import { Interval, Point, PointDisplay } from "../../services/Live/types";
import { DateTime, shouldUpdate, array, string, number, seriesColor, deepClone } from "../../utils";
import SearchBar from "../../components/SearchBar/SearchBar";
import Tooltip, { TooltipContent } from "../../components/Tooltip/tooltip";
import Graph from "../../components/OutcomeGraph/OutcomeGraph";
import moment from "moment";
import autobind from "../../libs/react-autobind";
import { DateRangePicker } from "../../libs/react-date-range";
import SmartTable from "../../components/SmartTable/SmartTable";
import Menu, { MenuAction } from "../../components/PopupMenu/menu";
import { actions as headerActions } from "../../components/Header/redux";

import dots from "../../assets/Icons/Group 2.png";
import red from "../../assets/Icons/Group 5.png";
import spinner from "../../assets/Icons/Group 6.png";
import RuleInstanceLastPingStatus from '../../components/RuleInstanceLastPingStatus/RuleInstanceLastPingStatus';
import rules from '../../services/rules';

@CSSModules(styles, { allowMultiple: true })
class Summary extends Component {
	constructor(props) {
		super(props);
		autobind(this);
		this.state = {
			showStack: false,
			calenderOpen: false,
			showTimes: false
		};

		this.props.getData();
		this.scrollElem = document.getElementById("content-scroll");
	}
	sameDay(d1, d2) {
		return (
			d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
		);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return shouldUpdate(this, nextProps, nextState, ["match"]);
	}

	toggleCalendar() {
		this.setState({ calenderOpen: !this.state.calenderOpen });
	}

	componentWillMount() {
		this.props.toggleHeaderSelect(false);
	}

	componentWillUnmount() {
		this.props.toggleHeaderSelect(true);
	}

	colorText(text) {
		if (/PASS/.test(text)) {
			return "#22B547";
		} else if (/CON/.test(text)) {
			return "#f4b042";
		} else if (/FAIL/.test(text)) {
			return "#f00";
		} else if (/ABORT/.test(text)) {
			return "#8B008B";
		}
	}

	changeTime(result) {
		result.selection.endDate = DateTime.endOf("day", result.selection.endDate);
		this.props.changeTime(result);
	}

	parseObject(item, indent = 0) {
		let rtns = "";
		if (Array.isArray(item)) {
			rtns += "\n";
			for (let index = 0; index < item.length; index++) {
				const t = item[index];
				if (t !== "" && t != null) {
					//add space for each indent
					array.fill(indent, x => (rtns += " "));
					//dont add indent if on first level
					rtns += this.parseObject(t, indent === 0 ? 0 : indent + 3) + "\n";
				}
			}
		} else if (item instanceof Date) {
			rtns += DateTime.parse(item, "D/M hh:mm a");
		} else if (typeof item === "object") {
			rtns += "\n";
			const keys = array.sort(Object.keys(item));
			for (let index = 0; index < keys.length; index++) {
				let prop = keys[index];
				if (item.hasOwnProperty(prop)) {
					const element = item[prop];
					if (element !== "" && element != null) {
						prop = string.capitalizeFirstLetter(string.insertSpaces(prop));
						//add space for each indent
						array.fill(indent, x => (rtns += " "));
						rtns += `${prop}: ${this.parseObject(element, indent + prop.length + 2)}\n`;
					}
				}
			}
		} else {
			rtns += item;
		}
		return rtns;
	}

	render() {
		return (
			<div styleName="outer">
				{/* click area to close calender */}
				{this.props.calenderOpen && <div onClick={this.toggleCalendar} styleName="toggle-area" />}
				<div styleName="header">
					<div styleName="header-spacer" />

					{this.props.isBusy ? (
						<CircularProgress />
					) : (
						<img styleName="refresh" onClick={this.props.getData} src={spinner} />
					)}
					<div styleName="select-group-container">
						<Button onClick={this.toggleCalendar} styleName="date-btn">
							{this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
								`${DateTime.formatToLocaleLongDate(this.props.time.startDate)}`}
							{!this.sameDay(this.props.time.startDate, this.props.time.endDate) &&
								`${DateTime.formatToLocaleLongDate(
									this.props.time.startDate
								)} - ${DateTime.formatToLocaleLongDate(this.props.time.endDate)}`}
							{this.props.calenderOpen && <ArrowDropUp style={{ fill: "rgba(0, 0, 0, 0.54)" }} />}
							{!this.props.calenderOpen && <ArrowDropDown style={{ fill: "rgba(0, 0, 0, 0.54)" }} />}
						</Button>
					</div>
					<div styleName="calendar-wrap" isopen={this.state.calenderOpen.toString()}>
						<div styleName="drpContainer">
							<DateRangePicker
								ranges={[this.props.time]}
								dragSelectionEnabled={false}
								showSelectionPreview={true}
								onChange={this.changeTime}
								showPreview={true}
							/>
							<div styleName="drpCloseButtonContainer">
								<div style={{ flex: 1 }} />
								<div styleName="drpCloseButton" onClick={this.toggleCalendar}>
									Close
								</div>
							</div>
						</div>
					</div>
				</div>
				<div styleName="content">
					<Card styleName="maincard">
						<CardContent styleName="cardcontent">
							<SmartTable
								smartTableId="sum-table"
								tableClass="tableclass"
								thClass="th"
								tdClass="td"
								sortChevronClass="sort-icon"
								columns={10}
								data={this.props.data}
								changeData={newData => this.props.changeData(newData)}
								useResponsiveColumns={true}
								breakOn="sm"
								allowColumnSort={true}
								rowsPerPage={0}
								stickyHeaderScrollRef={this.scrollElem}
								classes={styles}
							>
								<thead>
									<tr>
										<th sortable="siteName">Site</th>
										<th styleName="center" style={{minWidth:200}}>Hours Breakdown</th>
										<th styleName="center" sortable="totalHours">Run Hours</th>
										<th styleName="center" sortable="numErrors">Errors</th>
										<th styleName="center" sortable="numNotEnabled">Disabled Rules</th>
										<th styleName="center" sortable="numIsEnabled">Enabled Rules</th>
										<th styleName="center" sortable="totalRules">Total Rules</th>
										<th styleName="center" sortable="numNotHeartbeat">Heart beat errors</th>
									</tr>
								</thead>
								<tbody>
									{this.props.data.map((x, i) => {
										return (
											<tr key={i} styleName="row">
												<td style={{color:'#7F7F7F',fontSize:36,fontWeight:700}}>{x.siteName.replace("Site_", "")}</td>
												<td>
													<div style={{height:39,display:'flex',flexDirection:'row',flex:'1 1 0',borderTop:'1px solid #000',borderRight:'1px solid #000',borderBottom:'1px solid #000'}}>
														{
															x.totalHours > 0 &&
															<Tooltip delay={50}>
																<div style={{backgroundColor:'#FBC000',overflow:'hidden',borderLeft:'1px solid #000',height:'100%',width:((x.hoursPreCon / x.totalHours)*100) + '%',display:'flex',flexDirection:'row',flexWrap:'wrap',justifyContent:'center',alignItems:'center'}}>
																	<div style={{flex:'1 1 0',height:39}}></div>
																	<div style={{flex:'3 1 0',minWidth:70,fontSize:16,textAlign:'center'}}>
																		Pre con failed
																	</div>
																	<div style={{flex:'1 1 0',height:39}}></div>
																</div>
																<TooltipContent>
																	<div styleName="rrule-failed-tooltip">
																		{number.parseNumber(x.hoursPreCon, 0)} hours
																	</div>
																</TooltipContent>
															</Tooltip>
															
														}
														{
															x.totalHours > 0 &&
															<Tooltip delay={50}>
																<div style={{backgroundColor:'#DBEFF3',overflow:'hidden',borderLeft:'1px solid #000',height:'100%',width:((x.hoursPause / x.totalHours)*100) + '%',display:'flex',flexDirection:'row',flexWrap:'wrap',justifyContent:'center',alignItems:'center'}}>
																	<div style={{flex:'1 1 0',height:39}}></div>
																	<div style={{flex:'3 1 0',minWidth:70,fontSize:16,textAlign:'center'}}>
																		Paused
																	</div>
																	<div style={{flex:'1 1 0',height:39}}></div>
																</div>
																<TooltipContent>
																	<div styleName="rrule-failed-tooltip">
																		{number.parseNumber(x.hoursPause, 0)} hours
																	</div>
																</TooltipContent>
															</Tooltip>
														}
														<Tooltip delay={50}>
															<div style={{backgroundColor:'#C05046',overflow:'hidden',borderLeft:'1px solid #000',height:'100%',width:x.totalHours === 0 && x.numNotHeartbeat === x.totalRules ? '100%' : (((x.hoursFail / x.totalHours)*100) || '0') + '%',display:'flex',flexDirection:'row',flexWrap:'wrap',justifyContent:'center',alignItems:'center'}}>
																<div style={{flex:'1 1 0',height:39}}></div>
																<div style={{flex:'3 1 0',minWidth:70,color:'#000',fontSize:16,textAlign:'center'}}>
																	Failed
																</div>
																<div style={{flex:'1 1 0',height:39}}></div>
															</div>
															<TooltipContent>
																<div styleName="rrule-failed-tooltip">
																	{number.parseNumber(x.hoursFail, 0)} hours
																</div>
															</TooltipContent>
														</Tooltip>
														<Tooltip delay={50}>
															<div style={{backgroundColor:'#91D050',overflow:'hidden',borderLeft:'1px solid #000',height:'100%',width:x.totalHours === 0 && x.numNotEnabled === x.totalRules ? '100%' : (((x.hoursPass / x.totalHours)*100) || '0') + '%',display:'flex',flexDirection:'row',flexWrap:'wrap',justifyContent:'center',alignItems:'center'}}>
																<div style={{flex:'1 1 0',height:39}}></div>
																<div style={{flex:'3 1 0',minWidth:70,fontSize:16,textAlign:'center'}}>
																	Passed
																</div>
																<div style={{flex:'1 1 0',height:39}}></div>
															</div>
															<TooltipContent>
																<div styleName="rrule-failed-tooltip">
																	{number.parseNumber(x.hoursPass, 0)} hours
																</div>
															</TooltipContent>
														</Tooltip>
													</div>
												</td>
												<td styleName="center" style={{color:'#31859B',fontSize:36,fontWeight:700}}>{number.parseNumber(x.totalHours, 0)}</td>
												<td styleName="center" style={{color:'#f00',fontSize:36,fontWeight:700}}>{number.parseNumber(x.numErrors, 0)}</td>
												<td styleName="center" style={{color:'#7F7F7F',fontSize:36,fontWeight:700}}>{number.parseNumber(x.numNotEnabled, 0)}</td>
												<td styleName="center" style={{color:'#7F7F7F',fontSize:36,fontWeight:700}}>{number.parseNumber(x.numIsEnabled, 0)}</td>
												<td styleName="center" style={{color:'#7F7F7F',fontSize:36,fontWeight:700}}>{number.parseNumber(x.totalRules, 0)}</td>
												<td styleName="center" style={{color:'#f00',fontSize:36,fontWeight:700}}>{number.parseNumber(x.numNotHeartbeat, 0)}</td>
											</tr>
										);
									})}
								</tbody>
							</SmartTable>
						</CardContent>
					</Card>
				</div>
			</div>
		);
	}
}

const bindAction = dispatch => {
	return {
		changeData: data => dispatch(actions.onGetData(data)),
		changeTime: time => dispatch(actions.changeTime(time)),
		getData: () => dispatch(actions.getData()),

		toggleHeaderSelect: (val) => dispatch(headerActions.toggleHeaderSelect(val)),

		navigate: (uri, data) => dispatch(router.push(uri, data)),
		goBack: () => dispatch(router.goBack())
	};
};

const mapStateToProps = state => ({
	data: state.summary.data,
	time: state.summary.time,
	
	isBusy: state.summary.isBusy,
	errors: state.summary.errors
});

export default connect(
	mapStateToProps,
	bindAction
)(Summary);


// WEBPACK FOOTER //
// ./src/ui/Summary/Summary.js